module.exports = __webpack_public_path__ + "static/join-driver-fca3de7e55dbb793c219d9b50322c148.jpg";